<template>
  <div class="order-wrapper">
    <portal target-el="#filter">
      <PrimaryFilter
        :menuOptions="menuOptions"
        :selectedCategory="seletedCategory"
        :enableSearchPopup="enableSearchPopup"
        :searchParameters="searchParameters"
        :preSearchedParams="searchedParams"
        :buttonsList="buttonsList"
        :isUploading="isUploading"
        @getExcel="getExcel"
        @bulkUpload="bulkUpload"
        @rejectDownload="rejectDownload"
        @exportData="exportData"
        @searchByParameter="searchByParams"
        searchText="Search"
      />
    </portal>
    <!-- <div class="flex-container page-filter">
      <div class="flex-item">
        <FilterWrapper
          :values="filterTags"
          @openSliderLeft="openSlideleft = !openSlideleft"
        >
        </FilterWrapper>
      </div>
    </div> -->
    <!-- Removed class slideleft_drawer from below div -->
    <div class="top" :class="{ openSlideleft: openSlideleft }">
      <div
        class="slideleft_content"
        v-infinite-scroll="loadMore"
        infinite-scroll-disabled="loadCheck"
        infinite-scroll-throttle-delay="400"
        infinite-scroll-distance="10"
      >
        <MdmHeader
          :headers="sectionHeaders"
          :hasColumnPicker="true"
          :noCheckbox="true"
          :maxDisplayColumn="maxDisplayColumn"
        />
        <div v-if="isLoading" class="paymentloader"></div>
        <div v-else-if="list.length === 0" class="emptydiv">
          <div class="paymentempty"></div>
          <div class="emptytext">No data found!</div>
        </div>
        <MdmRow
          v-else
          v-for="(item, index) in activityTimesList"
          :key="index"
          :data="item"
          :headers="sectionHeaders"
        />
      </div>
      <!-- <div class="slideleft_menu">
        <SecFilter
          v-if="!isLoading"
          :selectedFilters="filterConstant"
          :filters="filters"
          @search="searchApply"
          @updateOption="updateOption"
          @reset="resetApply"
        />
      </div> -->
    </div>
  </div>
</template>
<script>
/* eslint-disable import/no-extraneous-dependencies */
import { mapState, mapGetters } from 'vuex';
import MdmHeader from '@common/components/HeaderV2';
import MdmRow from '@common/components/mdm-v2/Row';
import PrimaryFilter from '@/components/common/PrimaryFilter';
import SharedMdm from '@/components/mixins/SharedMdmV2';
import {
  maxDisplayColumn,
  filters,
  statusList,
} from '@/constants/mdm-v2/activity-time';
import FilterWrapper from '@common/components/FilterWrapperV2';
import SecFilter from '@common/components/SecFilter';
import SecFilterMixin from '@common/mixins/SecFilterMixin';
import { mdmType } from '@common/constants/mdm';

export default {
  name: 'ActivityTime',
  components: {
    PrimaryFilter,
    MdmHeader,
    MdmRow,
    FilterWrapper,
    SecFilter,
  },
  mixins: [SharedMdm, SecFilterMixin],
  data() {
    return {
      openSlideleft: false,
      maxDisplayColumn,
      defaultValues: {},
      filterConstant: [],
      filters,
      statusList,
      currentSection: '',
      HeaderConstants: [],
    };
  },
  async created() {
    this.setDefaults();
    this.loadSearchFromSession();
    this.loadFilterFromSession();
    try {
      this.currentSection = this.$router.history.current.name.toLowerCase();
      // call to get client config of headers
      await this.$store.dispatch('mdmV2/getHeadersFromConfig', {
        section: this.currentSection,
      });
      if (this.activityTimeHeaders && this.activityTimeHeaders.length) {
        // get headers from config
        this.sectionHeaders = this.activityTimeHeaders.map((_obj) => {
          const activityTimeHeader = {};
          activityTimeHeader.colSpan = _obj.colSpan;
          activityTimeHeader.column = _obj.name;
          activityTimeHeader.isSearchable = _obj.isSearchable;
          activityTimeHeader.label = _obj.label;
          activityTimeHeader.tlabel = _obj.tlabel;
          activityTimeHeader.name = _obj.name;
          activityTimeHeader.truncateOn = _obj.truncateOn;
          activityTimeHeader.required = _obj.required;
          activityTimeHeader.show = _obj.show;
          return activityTimeHeader;
        });
      }
      this.loadMore();
    } catch (err) {
      this.$errorMessage({ message: this.$t('APP_CATCH_ERR') });
      throw err;
    }
  },
  computed: {
    ...mapState('mdmV2', ['isLoading', 'all', 'isUploading']),
    ...mapGetters({
      configurations: 'app/configurations',
      activityTimeHeaders: 'mdmV2/header',
    }),
    activityTimesList() {
      return this.list.map((item) => {
        const newObj = {};
        newObj.id = item.id;
        newObj.route_name = item.route_name;
        newObj.source = item.source.reference_id;
        newObj.destination = item.destination.reference_id;
        newObj.assignment = item.assignment;
        newObj.truck_in = item.truck_in;
        newObj.truck_out = item.truck_out;
        newObj.reach = item.reach;
        newObj.material_invoice = item.material_invoice;
        newObj.shipment_number = item.shipment_number;
        newObj.updated_by = item.updated_user && item.updated_user.email_id;
        return newObj;
      });
    },
  },
  methods: {
    setDefaults() {
      [this.defaultValues.status] = this.statusList;
    },
    constructConstantForFilter() {
      this.filterConstant = [
        [
          {
            type: 'List',
            category: this.filters.STATUS,
            default: this.defaultValues.status,
            selected: this.defaultValues.status,
            list: this.statusList,
            idLabel: 'id',
            queryParamString: 'status',
            optional: true,
          },
        ],
      ];
    },
    resetApply() {
      this.resetAll();
      this.searchApply();
    },
    searchApply() {
      this.applyFilters();
      this.openSlideleft = false;
      const filter = this.constructFilterPayload();
      this.searchByFilter(filter);
    },
    loadFilterFromSession() {
      this.loadFilters();
      this.applyFilters();
      this.filterParams = this.constructFilterPayload();
    },
    loadSearchFromSession() {
      const sessionSearchParamsJSON =
        localStorage.getItem(`${this.$route.name}-search-popup`) || '{}';
      const sessionSearchParams = JSON.parse(sessionSearchParamsJSON);
      this.searchedParams = { ...this.searchedParams, ...sessionSearchParams };
    },
    searchByParams(params) {
      this.searchByParameter(params);
      // Located inside SharedMdm Mixin -> @/components/mixins/SharedMdmV2
      this.saveSearchToSession(this.searchedParams);
    },
    async exportData(entityType) {
      try {
        const sectionType = mdmType.activity_time;
        const params = Object.assign({
          type: sectionType,
        }, this.searchedParams);
        const hasData = await this.$store.dispatch('mdm/export', {
          section: 'activity_time',
          params,
        });
        if (hasData) {
          this.$successMessage({ message: this.$getSuccess(hasData) });
        }
        if (hasData.error) {
          this.$errorMessage({ message: hasData.error });
        }
      } catch (error) {
        this.$errorMessage({ message: this.$t('MDM_EXPORT_FAILS') });
      }
    },
  },
};
</script>
